import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Field,
  reduxForm,
} from 'redux-form';
import {
  Card, CardBody, Row, Col, Container, Badge, Label,
} from 'reactstrap';
import TextBox from '../../../../shared/components/form/TextBox';
import renderCheckBoxField from '../../../../shared/components/form/CheckBox';
import LoadingSpinner from '../../../../shared/components/LoadingSpinner';
import setPropsAsInitialValues from '../../../../helpers/setPropsAsInitialValues';
import validate from './validate';

class AddInscriptionForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onStudentEnrollmentChanges: PropTypes.func.isRequired,
    handleFilterChangeText: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    loading: PropTypes.bool,
    alumnoObj: PropTypes.shape({}),
    examen: PropTypes.shape({}).isRequired,
    alumnos: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    filterValue: PropTypes.string,
  }

  static defaultProps = {
    submitting: false,
    loading: false,
    alumnoObj: {},
    filterValue: '*',
  }

  getShowQuantities = () => (
    [{
      value: 1,
      description: 'Cantidad',
      checked: true,
    }]
  );

  render() {
    const {
      submitting,
      handleSubmit,
      loading,
      onStudentEnrollmentChanges,
      handleFilterChangeText,
      onBack,
      alumnos = [],
      filterValue,
    } = this.props;

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="card__title">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitting}
                onClick={handleSubmit}
              >Guardar
              </button>
              <button
                type="submit"
                className="btn btn-outline-secondary"
                onClick={onBack}
              >Cancelar - Volver
              </button>
            </div>
            {(
              <>
                <Col md={12} lg={12}>
                  <div className="card__title" style={{ marginBottom: '0px' }}>
                    <h5 className="bold-text" style={{ fontSize: 17 }}>
                      No Inscriptos:
                      <Badge
                        style={{ padding: '0.2rem', fontSize: 18 }}
                        color="secondary"
                        pill
                      >
                        {alumnos.filter(a => !a.selected).length}
                      </Badge>
                    </h5>
                  </div>
                </Col>
              </>
            )
            }
            <Row dir="ltr">
              <Col md={12} xl={12} sm={12}>
                <div
                  className="summary-card__item fs-16 form"
                  style={{
                    fontSize: 17,
                    display: 'flex',
                    fontWeight: 'bold',
                  }}
                >
                  <Label
                    style={{ paddingTop: 0, paddingBottom: 0 }}
                    for="filterValue"
                    sm={3}
                    className="form__form-group-label text-right"
                  >
                    Filtrar alumnos:
                  </Label>
                  <Col sm={9}>
                    <div className="form__form-group-field">
                      <Field
                        name="filterValue"
                        component={TextBox}
                        placeholder="Texto a buscar"
                        autoComplete="false"
                        type="text"
                        onChange={handleFilterChangeText}
                        maxLength={32}
                        defaultValue={filterValue}
                      />
                    </div>
                  </Col>
                </div>
              </Col>
            </Row>
            {
              loading
                ? <LoadingSpinner />
                : (
                  <Form className="form" onSubmit={handleSubmit}>
                    <Container className="summary-container">
                      <Row dir="ltr">
                        {alumnos.map(s => (
                          <Col md={6} xl={4} sm={12} key={`col_student_${s.student}`}>
                            <div
                              key={`div_student_${s.value}`}
                              className="summary-card__item fs-16"
                              style={{
                                fontSize: 15,
                                display: 'flex',
                                marginTop: '10px',
                              }}
                            >
                              <Field
                                key={`student_${s.student}`}
                                name={`student_${s.student}`}
                                component={renderCheckBoxField}
                                label={`${s.doc}/${s.year}: ${s.name}`}
                                className={s.selected ? 'checked' : ''}
                                value={s.selected}
                                defaultChecked={s.selected}
                                onChange={v => onStudentEnrollmentChanges(v, s)}
                              />
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </Container>
                  </Form>
                )
            }
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const ReduxAddInscriptionForm = reduxForm({
  form: 'AddInscriptionForm',
  validate,
  enableReinitialize: true,
})(AddInscriptionForm);

export default setPropsAsInitialValues(ReduxAddInscriptionForm);
